module.exports = __webpack_public_path__ + "static/img/right_dis.21a28738.png";